import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import connectActions from 'utils/connectActions'

const mapActionsToProps = ({ action }) => ({
  pollAction: action
})

export default
@connectActions(mapActionsToProps)
class ActionPolling extends PureComponent {
  static propTypes = {
    pollAction: PropTypes.object.isRequired,
    delay: PropTypes.number.isRequired,
    params: PropTypes.any,
  }

  componentDidMount() {
    this.poll()
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  poll = () => {
    const { delay, pollAction, params } = this.props
    this.timeout = setTimeout(async () => {
      try {
        await pollAction.run({ params, updateComponent: false })
        this.poll()
      } catch (e) {
        // do nothing
      }
    }, delay)
  }

  render() {
    return null
  }
}
